import type { GetStaticPaths, GetStaticProps, NextPage } from "next";
import { useTranslation } from "react-i18next";
import { NewsArticleDetail } from "src/domains/shared/components/Home/News/NewsArticleDetail";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";
import {
  NEWS_ARTICLES,
  formatPublishedDate,
} from "src/domains/shared/components/Home/News/newsArticles";

interface NewsDetailProps {
  id: string;
}

const NewsDetail: NextPage<NewsDetailProps> = ({ id }) => {
  const { t, i18n } = useTranslation("landing");

  const article = NEWS_ARTICLES.find((item) => item.id === id);

  if (!article) return null;

  return (
    <SiteLayout
      meta={{
        title: t("site.meta.article.title", { title: article.title }),
        description: article.summary,
      }}
    >
      <NewsArticleDetail
        article={article}
        formattedDate={formatPublishedDate(article.publishedAt, i18n.language)}
      />
    </SiteLayout>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: NEWS_ARTICLES.map((article) => ({ params: { id: article.id } })),
  fallback: false,
});

// 기사 데이터는 이미 번들에 포함된 정적 배열이므로 id만 전달하고 컴포넌트에서 조회한다.
// (optional 필드의 undefined 직렬화 불가 + __NEXT_DATA__ 중복 임베드 방지)
export const getStaticProps: GetStaticProps<NewsDetailProps> = ({ params }) => {
  const id = typeof params?.id === "string" ? params.id : "";
  if (!NEWS_ARTICLES.some((article) => article.id === id)) {
    return { notFound: true };
  }
  return { props: { id } };
};

export default NewsDetail;
